<div class="navBar">
    <div class="navBar-btn">
        <button (click)="backToTransaction()"
            class="backToReport"><mat-icon>keyboard_arrow_left</mat-icon>
            <span>{{reportService.isProjectDetailOpen() ? ('User.Back'|translate) :
                ('reports.backToReport'|translate)}}</span> </button>
    </div>

    <div class="property-detailMenu" [ngClass]="{ 'property-detailMenuAr' : currentReportView === 2}">
        <app-report-sub-menu [menuList]="overViewMenu" [isPropertyDetailPage]="true"
            (menuChangeValue)="menuChangeValue($event)" [activeTabName]="'property'"></app-report-sub-menu>
    </div>
</div>

<div class="report-property-detail">
  <!-- Overview Section -->
  <div class="report-tabsection-d" id="{{ housePropertyDetailMenuEnum.overview}}"
  [ngClass]="{ 'scroll': currentScroll === housePropertyDetailMenuEnum.overview}">
      <app-property-details-overview [Property_Uid]="propertyInfo?.property_uid" [property_cat]="propertyCategory.VillaHouse"></app-property-details-overview>
  </div>

 <!-- Transaction History -->
  <div class="report-model report-tabsection-d" id="{{ housePropertyDetailMenuEnum.transactionHistory}}"
  [ngClass]="{ 'scroll': currentScroll === housePropertyDetailMenuEnum.transactionHistory}">
    <app-property-transaction [propertyInfo]="propertyInfo" [report_category]="propertyCategory.VillaHouse"></app-property-transaction>
  </div>
</div>